// Application main entry point

import './vendor';

import './app/core/utils/time';
import './app/core/utils/deep-equal';
import './app/core/utils/isset';
import './app/core/utils/version';
import './app/core/utils/import-script';
import './app/core/utils/import-style';

import '../j/feedback';
import '../j/util';
import '../j/dialogs';
import '../j/shop';
import '../j/gallery';
import '../j/map';
import '../j/services';
import '../j/parental_lock';
import '../j/time_picker';
import '../j/video';
import '../j/languageSelector';
import '../tv/main.js';
import '../tv/tv.js';
import '../tv/nav_tv.js';

import {inject} from './app/core/di';
import {App} from './app/app';

function main() {
  inject(App);
}

main();
